
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.19 1.172l-7 3.11A2.008 2.008 0 003 6.112v4.7c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-4.7a2.008 2.008 0 00-1.19-1.83l-7-3.11a1.988 1.988 0 00-1.62 0zm.81 10.63h7c-.53 4.12-3.28 7.79-7 8.94v-8.93H5v-5.7l7-3.11v8.8z"}})])
          )
        }
      }
    